"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EChartClick = void 0;
exports.EChartClick = new CustomEvent('chart-click', { detail: { data: {} } });
